<div class="advantages">
  <div class="advantages__card" *ngFor="let item of 'spiritPage.advantages.items' | translate">
    <h3 class="advantages__card__title">{{ item.title }}</h3>
    <p class="advantages__card__description">{{ item.description }}</p>
  </div>
</div>
